import { IKpi, TResultType } from 'legacy/lut/classes/models/partner360/ELT/financialData/kpi/IKpi'

export interface ITableData {
  category: string
  name: string
  results: Record<string, TResultType[] | null>
}

export const transformDataForTable = (data: IKpi[]): ITableData[] => {
  return data.reduce<ITableData[]>((acc, { category, items }) => {
    items.reduce((_, { name, results }, index) => {
      acc.push({
        category: index === 0 ? category : '',
        name,
        results: Object.fromEntries(
          Object.entries(results ?? {}).map(([key, values]) => [key, values.length ? values : null])
        ),
      })
      return acc
    }, acc)

    return acc
  }, [])
}
